module.exports = __webpack_public_path__ + "img/new-entry.402c0281.svg";